import { useMemo } from 'react';

import { Box, Typography } from '@mui/material';

import FactsheetDialogButton from '@/components/FactsheetDialogButton';

const HeadContent = ({
  code,
  alias,
  currency,
  units
}: {
  code: string;
  alias: string;
  currency: string;
  units: string;
}) => {
  const columns = useMemo(() => {
    return [
      {
        label: 'Alias',
        value: alias
      },
      {
        label: 'Code',
        value: code
      },
      {
        label: 'Currency',
        value: currency,
        align: 'end'
      },
      {
        label: 'Units',
        value: units,
        align: 'end'
      },
      {
        label: 'Factsheet',
        value: <FactsheetDialogButton code={code} />,
        align: 'end'
      }
    ];
  }, [alias, code, currency, units]);

  return (
    <Box sx={{ display: 'flex', gap: 2, flex: 1, px: '8px', mt: '16px' }}>
      {columns.map(({ label, value, align }) => (
        <Box
          key={label}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: `flex-${align ?? 'start'}`,
            flex: 1
          }}
        >
          <Typography sx={{ fontSize: '10px' }}>{label}</Typography>
          <Typography sx={{ fontSize: '12px' }}>{value}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default HeadContent;
